module.exports = __webpack_public_path__ + "img/lootbox-epic-11.d413aa6f.jpg";